import ImageTransform from "ui/canvas/ImageTransform";
import AbstractCanvasTransformTool from "ui/canvas/transforms/AbstractCanvasTransformTool";

/**
 * Transform layer: make skew for each frame
 */
export default class CanvasFlip extends AbstractCanvasTransformTool {
	/**
	 * @param {boolean} [isVertical]
	 */
	constructor(isVertical = false) {
		super();

		/**
		 * @type {boolean}
		 * @private
		 */
		this._isVertical = isVertical;
	}

	/**
	 * @inheritDoc
	 */
	_processReference(layer, fromFrame, toFrame) {
		const t = new ImageTransform();
		const t2 = layer.getTransform(fromFrame);

		if (this._isVertical) {
			t.flipY = !t2.flipY;
			t.translateY = this._center.y - (this._sceneHeight - this._center.y);
		} else {
			t.flipX = !t2.flipX;
			t.translateX = this._center.x - (this._sceneWidth - this._center.x);
		}

		layer.updateTransformForFrames(t, fromFrame, toFrame);
	}

	/**
	 * @inheritDoc
	 */
	_transformImage(ctx, mat, frameIndex) {
		if (this._isVertical) {
			mat.scale(1, -1);
		} else {
			mat.scale(-1, 1);
		}
	}
}
